import {Injectable} from '@angular/core';

@Injectable()
export class Scheduler {
    public scheduleCallback(periodInMillis: number, callback: () => void) {
        setTimeout(callback, periodInMillis);
    }
}